import React, { useEffect } from "react";
import { ModalBackD } from "../components/Style";
import styled from "styled-components";
import { device } from "../hooks/device";
import chromeIcon from "../img/chrome.svg";
import whaleIcon from "../img/whale.svg";
import edgeIcon from "../img/edge.svg";
import useScrollLockThree from "../hooks/useScrollLockThree";
import { setCookie } from "../Cookie";

const BroswerPopUp = ({ setBrowserModal }) => {
  const goBack = () => {
    setBrowserModal(false);
  };

  useEffect(() => {
    window.history.pushState("", null, window.location.href);
    window.addEventListener("popstate", goBack);
    return () => {
      window.removeEventListener("popstate", goBack);
    };
  }, []);

  useScrollLockThree();

  return (
    <>
      <ModalBackD />
      <StBrowserPopUp>
        <div className="bodyBox">
          <div className="titlePart">
            Proctormatic currently supports the following web browsers:
            {/* <br className="onlyForPc" /> */}
          </div>
          <div className="suggestBluePart">
            For the best experience, we recommend using
            <span>Google Chrome, Microsoft Edge</span>, or{" "}
            <span>Naver Whale</span> :)
          </div>
          <div className="suggestPart">
            Proctormatic does not support Internet Explorer. To use
            Proctormatic, update your browser or switch to a different browser.
          </div>
          <div className="downLinkPart">
            <div
              className="linkForm"
              onClick={(e) => {
                window.open("https://www.google.com/intl/en_us/chrome/");
                e.preventDefault();
              }}
            >
              <img src={chromeIcon} />
              <div>Google Chrome</div>
              <span>Download</span>
            </div>
            <div
              className="linkForm"
              onClick={(e) => {
                window.open(
                  "https://www.microsoft.com/en-us/edge/download?form=MA13FJ"
                );
                e.preventDefault();
              }}
            >
              <img src={edgeIcon} />
              <div>Microsoft Edge</div>
              <span>Download</span>
            </div>
          </div>
        </div>
        <div className="buttonBox">
          <div
            onClick={() => {
              setBrowserModal(false);
              setCookie("browserPopup", true);
            }}
          >
            Do not open for a day
          </div>
          <div className="greyBar" />
          <div
            onClick={() => {
              setBrowserModal(false);
            }}
          >
            Close
          </div>
        </div>
      </StBrowserPopUp>
    </>
  );
};

const StBrowserPopUp = styled.div`
  position: fixed;
  background-color: #eeeff0;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  .bodyBox {
    padding: 32px 24px;
    display: grid;
    .titlePart {
      font-size: 23px;
      font-family: "bold";
      line-height: 34px;
      word-break: keep-all;
    }
    .suggestBluePart {
      color: #2276dc;
      line-height: 24px;
      margin: 24px 0 14px;
      span {
        font-family: "bold";
      }
    }
    .suggestPart,
    .suggestBluePart {
      font-size: 16px;
      font-family: "regular";
      line-height: 24px;
    }
    .downLinkPart {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin-top: 28px;
      .linkForm {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-family: "regular";
        line-height: 18px;
        border-radius: 9.176px;
        background: #fff;
        padding: 12.5px;
        cursor: pointer;
        img {
          width: 29px;
          height: 29px;
          margin-bottom: 6px;
        }
        span {
          color: #2276dc;
        }
      }
    }
  }
  .buttonBox {
    display: grid;
    grid-template-columns: 1fr 1px 1fr;
    padding: 0 24px;
    height: 60px;
    align-items: center;
    background-color: white;
    text-align: center;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    .greyBar {
      width: 1px;
      height: 14px;
      background-color: #d6d9dd;
    }
  }
  @media ${device.pcTab} {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    height: 560px;
    z-index: 100;
    .bodyBox {
      padding: 46px;
      .titlePart {
        font-size: 30px;
        line-height: 44px;
      }
      .suggestBluePart {
        /* font-size: 16px; */
        margin: 30px 0 15px;
      }
      .downLinkPart {
        margin-top: 30px;
        .linkForm {
          /* width: 125px; */
          height: 125px;
          box-sizing: border-box;
          font-size: 16px;
          line-height: 24px;
          img {
            width: 38px;
            height: 38px;
          }
        }
      }
    }
  }
  @media ${device.mobile} {
    .onlyForPc {
      display: none;
    }
    width: 100%;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 100;
    border-radius: 32px 32px 0px 0px;
  }
`;

export default BroswerPopUp;
